import { GetMedicalCodesTypeEnum } from "@/services";
import { CodeBlockDef, CodeBlockLabels } from "./initial-f2f-types";

export const MEDICAL_CODE_PAGE_SIZE = 20;
export const SCREENER_TYPE_PAGE_SIZE = 20;
export const SCREENING_LIST_HEADING = "Screening Assessments";
export const SCREENING_BLOCK: CodeBlockLabels = {
  heading: "",
  nameLabel: "Assessment",
  summaryLabel: "Assessments",
  placeholder: "Open the list or search by assessment name",
  hint: "Select assessment, then click on Add assessment",
  buttonLabel: "Add assessment",
  duplicateMessage: "This assessment is already added",
  isSearchOnly: true,
};
export const CODE_SEARCH_VISIBLE_TAGS = 2;
export const CODE_SEARCH_TAG_MAX_WIDTH_PX = 260;
export const CODE_SEARCH_TAG_HEIGHT_PX = 20;
export const CODE_LIST_VISIBLE_ROWS = 5;
export const CODE_LIST_ROW_HEIGHT_PX = 56;
export const CODE_NOTES_LABEL = "Notes";
export const REQUIRED_MARK = "*";
export const CODE_LIST_ROW_GAP_PX = 8;
export const CODE_LIST_MAX_HEIGHT_PX =
  CODE_LIST_VISIBLE_ROWS * CODE_LIST_ROW_HEIGHT_PX +
  (CODE_LIST_VISIBLE_ROWS - 1) * CODE_LIST_ROW_GAP_PX;
export const CODE_BLOCKS: Record<"diagnosis" | "cpt", CodeBlockDef> = {
  diagnosis: {
    type: GetMedicalCodesTypeEnum.Icd,
    heading: "ICD CODES",
    nameLabel: "Diagnosis",
    codeLabel: "ICD-10",
    summaryLabel: "Diagnosis",
    placeholder: "Open the list or search by diagnosis name or ICD-10 code",
    buttonLabel: "Add diagnosis",
    duplicateMessage: "This diagnosis is already added",
    isNumbered: true,
    isSearchOnly: true,
  },
  cpt: {
    type: GetMedicalCodesTypeEnum.Cpt,
    heading: "CPT CODES",
    nameLabel: "Service",
    codeLabel: "CPT",
    summaryLabel: "CPT codes",
    placeholder: "Open the list or search by CPT code or service",
    buttonLabel: "Add CPT code",
    duplicateMessage: "This CPT code is already added",
    isSearchOnly: true,
  },
};
